(function ($) {
	"use strict";

	$.navigation = new Object({
		_scrollPos: window.scrollY,

		init: function () {
			var preload = document.querySelector('.preload');
			preload.classList.remove('preload');

			// Initial aria-state for the menu button in closed state.
			var tabContainer = $('.menu, .menu__container');
			var menuContainer = $('.menu__container');
			var menuButton = $('.menu__button');
			var tabbableMenuElements = tabContainer.find('select, input, textarea, button, a').filter(':visible');
			var firstTabbable = tabbableMenuElements.first();
			var lastTabbable = tabbableMenuElements.last();
			// Initial aria-state and style for the overlay
			// for hiding the closed burger menu (also for the keyboard).
			// visibility: hidden; is the same like display: none;
			// withouth removing the space for the transition animation.
			// Always remember: The current focus is always the 'eye' of
			// the screen reader user and visual indicator (if styled accordingly)
			// for the keyboard only user.

			function isMenuOpen() {
				return menuButton.attr('aria-expanded') === 'true';
			}

			function openMenu() {
				$('body').addClass('no-scroll menu--active');
				menuButton
					.addClass('is-active')
					.attr('aria-expanded', 'true');
				menuContainer
					.css({'visibility': 'visible'})
					.attr('aria-hidden', 'false');
				firstTabbable.focus();
			}

			function closeMenu() {
				$('body').removeClass('menu--active');
				menuButton
					.removeClass('is-active')
					.attr('aria-expanded', 'false')
					.focus();
				menuContainer
					.css({'visibility': 'hidden'})
					.attr('aria-hidden', 'true');
			}

			menuButton.attr('aria-expanded', 'false');

			// redirect last tab to first focusable element
			lastTabbable.on('keydown', function focusFirstTabbableMenuElement(e) {
				if ((e.which === 9 && !e.shiftKey && isMenuOpen())) {
					e.preventDefault();
					firstTabbable.focus();
				}
			});

			// redirect first shift+tab to last focusable element
			firstTabbable.on('keydown', function focusLastTabbableMenuElement(e) {
				if ((e.which === 9 && e.shiftKey && isMenuOpen())) {
					e.preventDefault();
					lastTabbable.focus();
				}
			});

			// allow escape key to close the menu via keyboard
			$(document).on('keyup', function closeMenuWithEscapeKey(e) {
				if (e.keyCode === 27 && isMenuOpen()) {
					if (menuButton.attr('aria-expanded') === 'true') {
						menuButton.click();
					}
				}
			});

			menuContainer.on('transitionend', function showGlobalScrollbarWhenMenuIsClosed(event) {
				if (event.target === menuContainer.get(0) && menuContainer.attr('aria-hidden') === 'true') {
					$('body').removeClass('no-scroll');
				}
			});

			menuButton.on('click', function toggleMenu(e) {
				e.preventDefault();
				if (isMenuOpen()) {
					closeMenu();
				} else {
					openMenu();
				}
			});

			$('.navigation .has-sub').children(":first").attr('aria-haspopup', 'true');
			if ($('.navigation .has-sub .is-active').length <= 0) {
				$('.navigation .has-sub:first-child a').addClass('is-active');
			}
			$(document).on('click', '.navigation .has-sub > a, .navigation .has-sub > button', function (e) {
				e.preventDefault();
				if ($.breakpoints.breakpointDown('md') !== true) {
					$('.navigation .has-sub .is-active').removeClass('is-active');
				}
				$(this).toggleClass('is-active');
			});
		}
	});

})(jQuery);
